import React from "react";
import OperatorServiceTickets from "../../components/dashboard/OperatorServiceTickets";

const OperatorPlatformGest = () => (
  <OperatorServiceTickets
    serviceCode="management"
    title="Facturation"
    lead="Les demandes liées au module de facturation de Gestion 360."
  />
);

export default OperatorPlatformGest;
